type DepartmentFilterValue = number | string | null | undefined;

function isNoDepartmentValue(value: DepartmentFilterValue): boolean {
    return value === '' || value === null || value === undefined;
}

function toDepartmentNumber(value: DepartmentFilterValue): number | null {
    if (isNoDepartmentValue(value)) {
        return null;
    }

    const departmentId = Number(value);
    return Number.isNaN(departmentId) ? null : departmentId;
}

export function isDepartmentIncludedInOrderIntegration(
    selectedDepartments: DepartmentFilterValue[] | null | undefined,
    departmentId: DepartmentFilterValue,
): boolean {
    if (!selectedDepartments?.length) {
        return true;
    }

    const normalizedDepartmentId = toDepartmentNumber(departmentId);
    const includesNoDepartment = selectedDepartments.some((item) => isNoDepartmentValue(item));

    if (normalizedDepartmentId === null) {
        return includesNoDepartment;
    }

    return selectedDepartments.some((item) => toDepartmentNumber(item) === normalizedDepartmentId);
}